<template> 
  <base-layout>
    <ul class="nav navbar-nav navbar-left" slot="toolbar_buttons">
      <li>
        <date-range-picker :datesRange="datesRange" @dates-range-updated="updatedDates"></date-range-picker>
      </li>
    </ul>      
    
    <!-- slot main -->
    
    <div id="dashboard-canvas" class="col-xs-12 main with-leads-table with-leads-table-active" slot="main">
      <!-- components -->
      <div class="row ls-charts">
          <h1>Requests <span v-if="stats.customer">- {{ stats.customer }}</span></h1>
                      
          <div class="row">
              <div class="col-xs-12">            
                  <div class="col-xs-2">
                      <div class="box">
                          <div class="panel stats">
                              <div class="panel-header">
                                  <h3>Total</h3>
                              </div>
                              <div class="panel-body">
                                  <div class="metrics-banner-text text-center">{{ stats.total }}</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  
                  <div class="col-xs-2">
                      <div class="box">
                          <div class="panel stats">
                              <div class="panel-header">
                                  <h3>OK</h3>
                              </div>
                              <div class="panel-body">
                                  <div class="metrics-banner-text text-center">{{ stats.ok }}</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  
                  <div class="col-xs-2">
                      <div class="box">
                          <div class="panel stats">
                              <div class="panel-header">
                                  <h3>Errors</h3>
                              </div>
                              <div class="panel-body">
                                  <div class="metrics-banner-text text-center">{{ stats.error }}</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  
                  <div class="col-xs-2">
                      <div class="box">
                          <div class="panel stats">
                              <div class="panel-header">
                                  <h3>Tests</h3>
                              </div>
                              <div class="panel-body">
                                  <div class="metrics-banner-text text-center">{{ stats.test }}</div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="col-xs-2">
                      <div class="box">
                          <div class="panel stats">
                              <div class="panel-header">
                                  <h3>% Error</h3>
                              </div>
                              <div class="panel-body">
                                  <div class="metrics-banner-text text-center">{{ errorRate | percentage }}</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="row">
              <div class="col-xs-12">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Requests by Day</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'requests_flow'"
                                            v-bind:bc-data="stats.requests_flow.series" 
                                            v-bind:bc-layout="stats.requests_flow.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="row">
              <div class="col-xs-12 col-md-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Stats by Campaign</h3>
                          </div>
                          <div class="panel-body">
                              <ls-stats-table :table-data="stats.stats_by_campaign" :table-layout="by_campaign_layout"></ls-stats-table>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="col-xs-12 col-md-6">
                  <div class="box">
                      <div class="panel">
                          <div class="panel-header">
                              <h3>Distribution by Campaign</h3>
                          </div>
                          <div class="panel-body">
                              <div class="col-xs-12 chart-wrapper">
                                  <ls-chart target-css-classes="chart" 
                                            :target-id="'counts_by_campaign'"
                                            v-bind:bc-data="stats.counts_by_campaign.series" 
                                            v-bind:bc-layout="stats.counts_by_campaign.layout">
                                  </ls-chart>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
 import Vue from 'vue';

 import {BaseLayout} from 'components/layouts/';
 import DateRangePicker from 'components/elements/DateRangePicker';
 import LsChart from 'components/elements/PlotlyJS/LSBasicChart';
 import LsStatsTable from 'components/elements/LsStatsTable';

 // Load the full build. 
 var _ = require('lodash');

 export default {
     components: {
         BaseLayout,
         LsChart,
         DateRangePicker,
         LsStatsTable
     },
     data () {
         return {
             /* These are part of colums */
             by_campaign_layout: {
                 header: [
                     {key: 'name', label: 'Campaign'},
                     {key: 'total', label: 'TOTAL'},
                     {key: 'ok', label: 'OK'},
                     {key: 'test', label: 'TEST'},
                     {key: 'error', label: 'ERROR'},
                 ]
             },
             stats: {
                 total: '-',
                 ok: '-',
                 error: '-',
                 test: '-',
                 requests_flow: {
                     'series': [],
                     'layout': {}
                 },
                 stats_by_campaign: [],
                 counts_by_campaign: {
                     'series': [],
                     'layout': {}
                 }
             },
             datesRange: {
                 from: null,
                 to: null,
                 date_field: null
             }
         };
     },
     computed: {
         errorRate() {
             if (this.stats.total != '-' && this.stats.error != '-'  && this.stats.total > 0) {
                 return this.stats.error/this.stats.total;
             }
             return '-';
         },
     },
     created () {
         var u = this.$store.state.user;
         BUS.$on('refreshDashboard', this.reload);
         this.datesRange.from =  moment().subtract(29, "days").format("YYYY-MM-DD");
         this.getStats();         
     },   
     methods: {
         reload() {
             let current = _.cloneDeep(this.datesRange);
             this.datesRange = null;
             this.datesRange = current;
         },
         getStats: _.debounce(function () {
             let req = {}
             if (this.datesRange) {
                 if (this.datesRange.from) {
                     req['from_date'] = this.datesRange.from;
                 }
                 if (this.datesRange.to) {
                     req['to_date'] = this.datesRange.to;
                 }
             }
             API.requests.stats(req)
                .then((res) => {
                    this.stats = res.data;
                })
         }),
         updatedDates(datesRange) {
             this.datesRange = datesRange;
             this.getStats();
         }
     }
 }
</script>

<style lang="scss" scoped>
 .dashboard-header {
   color: #ddd;
   border-bottom: 1px solid #ddd;
   margin-bottom: 4px;
   padding: 0px;
 }
 .dashboard-header .btn-group {
   display: inline-block;
   margin-top: 3px;
 }
 3.dashboard-header .col-xs-10,
 .dashboard-header .col-xs-2 {
   padding-left: 3px;
   padding-right: 3px;
 }
 .dashboard-header h3 {
   color: #ddd;
   font-size: 14pt;
 }
 .dashboard-header .btn-default {
   color: #ddd!important;
   border: 0px;
   border-radius: 0px;
   background: transparent;
 }
 .dashboard-header .btn-default:hover,
 .dashboard-header .btn-default:focus,
 .dashboard-header .btn-default:active {
   border: 0px;
   background: #aeaeae;
   shadow-box: 0;
   color: #555!important;
 }

 .empty-msg {
   margin: 30px auto;
 }


 /* Leads Queue styles */
 h1 .btn {
   background-color: transparent;
   margin-top: -8px;
 }

 h1 input {
   background: #fff;
   border: 0px!important;
   padding: 0px;
   padding-top: 4px;
   margin-top: -4px;
 }

 .leads-queue {
   padding: 0px!important;
   border: 1px solid #999;
   border-bottom: 0px;
   margin: 0px!important;
   float: none;
 }

 .leads-queue .chart-wrapper {
   padding: 0px!important;
   height: 100%!important;
 }

 .endeless-table-container {
   padding: 10px;
 }

 .leads-queue-wrapper {
   padding: 0px;
   position: absolute;
   height: 100%;
 }

 .leads-queue.full-height {
   position: absolute;
   height: 100%;
   width: 100%;
 }

 #dashboard-canvas {
   display: flex;
   flex-direction: column;
 }

 .ls-charts {
   flex: 100vh;
   flex-grow: 1;
   width: 100%;
   overflow: hidden;
   position: relative;
   margin: 0px!important;

   .chart-wrapper {
     height: 40vh;
     margin: 0;
   }
 }

 .ls-leads-table {
   display: flex;
   padding: 0px;
   position: relative;
   margin: 0px!important;
 }

 .with-leads-table .ls-charts {
   height: calc(100vh - 112px);
 }

 .with-leads-table.with-leads-table-active .ls-charts {
   height: 100%;
   flex-grow: 1;
   flex-basis: 35%;
   padding-bottom: 20px;
 }

 .with-leads-table.with-leads-table-active .ls-leads-table {
   height: 100%;
   flex-grow: 1;
   flex-basis: 65%;
 }

 .ls-charts-wrapper {
   position: absolute;
   height: calc(100% - 60px);
   overflow-y: auto;
   padding-bottom: 200px;
 }

 .ls-charts h1 {
   margin-left: 10px;
   margin-right: 10px;
 }

 .ls-charts > h4 {
   margin-top: -20px;
   margin-left: 30px;
   margin-right: 30px;
   padding: 5px 10px;
   background-color: #f5f5f5;
   border: #e3e3e3;
   border-radius: 0px 0px 4px 4px;
 }

 #dashboard-canvas h1 form {
   display: inline-block;
   width: 100%;
   height: 20px;
 }

 #dashboard-canvas h1 input[type="text"] {
   background-color: #efefef;
   display: inline-block;
   width: 90%;
 }

 .vue-grid-placeholder {
   background-color: #333!important;
   border-radius: 4px 4px 4px 4px;
 }

 .metrics-banner-text {
   font-size: 1.8em;
   font-weight: 600;
   color: #ff7a7c;
 }

 .ls-charts > .row {
   margin: 0px;
 }

 .box {

   padding: 10px;
 }

</style>



// WEBPACK FOOTER //
// VendorsHome.vue?bc8df8aa